export default __webpack_public_path__ + "static/blob1-d2605a902f0a29b9857330eed62e0fa9.svg";